import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getCollection, getTradeableItems } from '../utils/storage'
import styles from './Home.module.css'

export default function Home() {
  const [stats, setStats] = useState({ total: 0, tradeable: 0 })

  useEffect(() => {
    setStats({
      total: getCollection().length,
      tradeable: getTradeableItems().length,
    })
  }, [])

  return (
    <div className={styles.container}>
      <section className={styles.hero}>
        <h1>推し活グッズ管理</h1>
        <p>あなたの大切なコレクションを管理しよう</p>
        <Link to="/collection" className={styles.sellButton}>
          コレクションを見る
        </Link>
      </section>

      <section className={styles.section}>
        <h2>マイコレクション</h2>
        <div className={styles.stats}>
          <div className={styles.statCard}>
            <span className={styles.statNumber}>{stats.total}</span>
            <span className={styles.statLabel}>所持アイテム</span>
          </div>
          <div className={styles.statCard}>
            <span className={styles.statNumber}>{stats.tradeable}</span>
            <span className={styles.statLabel}>交換可能</span>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <h2>カテゴリ</h2>
        <div className={styles.categories}>
          <Link to="/search?category=acrylic" className={styles.categoryCard}>
            アクリルスタンド
          </Link>
          <Link to="/search?category=penlight" className={styles.categoryCard}>
            ペンライト
          </Link>
          <Link to="/search?category=photo" className={styles.categoryCard}>
            写真・ブロマイド
          </Link>
          <Link to="/search?category=other" className={styles.categoryCard}>
            その他
          </Link>
        </div>
      </section>
    </div>
  )
}
